var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__vev_calendar-wrapper"},[_c('cal-panel',{attrs:{"events":_vm.events,"calendar":_vm.calendarOptions,"selectedDay":_vm.selectedDayEvents.date},on:{"cur-day-changed":_vm.handleChangeCurDay,"month-changed":_vm.handleMonthChanged}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29fbb892","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/calendar/vue-event-calendar.vue
// module id = nfat
// module chunks = 0